export const DECA_ROUTES = {
  NEW: '/deca-new',
  TRANSFER: '/deca-transfer',
  SHIPPER_UPCOMING: '/deca-upcoming',
  CARRIER_UPCOMING: '/deca-carrier-upcoming',
  SHIPPER_PAST: '/deca-past',
  CARRIER_PAST: '/deca-carrier-past',
  DETAIL: '/deca-detail',
  EDIT: '/deca-edit',
  IMPORT_LIST: '/batch-imports',
  IMPORT_ERRORS: '/batch-import-errors',
} as const;
